import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

class MatchMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emitValues: this.props.serverSideRender,
    };
  }

  componentDidMount() {
    if (!window.matchMedia) {
      return;
    }

    if (this.props.throttle) {
      this.onResize = throttle(() => this.matchMedia(), this.props.throttle);
    } else if (this.props.debounce) {
      this.onResize = debounce(() => this.matchMedia(), this.props.debounce);
    } else {
      this.onResize = () => this.matchMedia();
    }

    window.addEventListener('resize', this.onResize);
    this.matchMedia();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  matchMedia() {
    this.props.matches.some(match => {
      if (window.matchMedia(match.mediaQuery).matches) {
        this.setState({ emitValues: match.values });
        return true;
      }
      return false;
    });
  }

  render() {
    const { emitValues } = this.state;
    return this.props.children(emitValues);
  }
}

const { number, string, arrayOf, shape, func, object } = PropTypes;
MatchMedia.propTypes = {
  children: func.isRequired,
  throttle: number,
  debounce: number,
  serverSideRender: object.isRequired,
  matches: arrayOf(
    shape({
      mediaQuery: string,
      emit: object,
    })
  ).isRequired,
};

MatchMedia.defaultProps = {
  throttle: null,
  debounce: null,
};

export default MatchMedia;
